import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { User } from '../../_models/user';
import { Subject } from 'rxjs';
import { Register } from '../../_models/register';
import { Address } from '../../_models/address';
import { Contacts } from '../../_models/contacts';
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-edit-contacts',
  templateUrl: './edit-contacts.component.html',
  styleUrls: ['./edit-contacts.component.css']
})
export class EditContactsComponent implements OnInit {

  contacts: any[] = [];
  statusText: string = "";
  geoCode: string = "";
  contactsErrorMessage: any[] = [];
  successMessage: any[] = [];
  owner: number;
  editContacts: any = {};
  addresses: any;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  statusText6: string;
  statusText7: string;
  statusText8: string;
  statusText9: string;
  statusText10: string;
  addressTypes: any = [];
  addressType: string;
  tabClicked = "address";
  statesList: any;
  citiesList: any;

  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, public route: ActivatedRoute, private api: ApiIntegration, private g: Globals, public user: User, public register: Register) {
    this.stateList();
    this.cityList();
    this.api.getAccountOwnerContacts(this.route.snapshot.params['id'], this.user.accountOwnerId, this.user.organizationId).subscribe((data: any) => {
      this.editContacts = data;
      this.addresses = this.editContacts.addresses;
      this.addressType = this.editContacts.addressType;
    }, err => {
      console.log(err);
    });
    this.g.loaderDisplay = "display";
    this.api.getValues("1", "ADDRESS_TYPE", "ADDRESS_TYPE", "ADDRESS_TYPE").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.addressTypes = data.tripleSetConfigDTOS;
    },
      err => {
        console.log(err);
        this.g.loaderDisplay = "";
      });
    this.g.page = "Edit Contact";
  }

  stateList() {
    this.api.getDistinctStates().subscribe((data: any) => {
      this.statesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  ngOnInit(): void {
  }

  tabChange(tab) {
    this.tabClicked = tab
  }

  selectCustomerType() {
    this.statusText10 = "";
    if (this.editContacts.customerType == '' || this.editContacts.customerType === null || this.editContacts.customerType === undefined || this.editContacts.customerType === 'undefined') {
      this.statusText10 = 'Please select customer type';
      return false;
    }
  }

  createContactName() {
    this.statusText2 = "";
    if (this.editContacts.contactName == '' || this.editContacts.contactName === null || this.editContacts.contactName === undefined || this.editContacts.contactName === 'undefined') {
      this.statusText2 = 'Please enter contact name';
      return false;
    }
  }

  cityList() {
    this.api.getDistinctCity().subscribe((data: any) => {
      this.citiesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  changeStateAndCity() {
    for (let add of this.addresses) {
      this.api.getCityAndStateByPinCode(add.zip).subscribe((data: any) => {
        add.city = data.city;
        add.state = data.state;
      }, err => {
        this.alertService.error('Error', err);
      });
    }
  }

  createEmail() {
    this.statusText3 = "";
    if (this.editContacts.email == '' || this.editContacts.email === null || this.editContacts.email === undefined || this.editContacts.email === 'undefined') {
      this.statusText3 = 'Please enter email';
      return false;
    }
  }

  createMobile() {
    this.statusText4 = "";
    if (this.editContacts.mobile == '' || this.editContacts.mobile === null || this.editContacts.mobile === undefined || this.editContacts.mobile === 'undefined') {
      this.statusText4 = 'Please enter Phone Number';
      return false;
    } else if (this.editContacts.mobile.toString().length != 10) {
      this.statusText4 = 'Phone number minimum 10 characters';
      return false;
    } else {
      let i = this.editContacts.mobile.toString().indexOf('0');
      if (i == 0) {
        this.statusText4 = "Number should not start with 0";
        return false;
      }
    }
  }

  createAddress() {
    this.statusText5 = "";
    for (let add of this.addresses) {
      if (add.address1 == '' || add.address1 === null || add.address1 === undefined || add.address1 === 'undefined') {
        this.statusText5 = 'Please enter address';
        return false;
      }
    }
  }

  createCity() {
    this.statusText6 = "";
    for (let add of this.addresses) {
      if (add.city == '' || add.city === null || add.city === undefined || add.city === 'undefined') {
        this.statusText6 = 'Please enter city';
        return false;
      }
    }
  }

  createState() {
    this.statusText7 = "";
    for (let add of this.addresses) {
      if (add.state == '' || add.state === null || add.state === undefined || add.state === 'undefined') {
        this.statusText7 = 'Please enter state';
        return false;
      }
    }
  }

  createZip() {
    this.statusText8 = "";
    for (let add of this.addresses) {
      if (add.zip == '' || add.zip === null || add.zip === undefined || add.zip === 'undefined') {
        this.statusText8 = 'Please enter ZIP';
        return false;
      } else if (add.zip.toString().length != 6) {
        this.statusText8 = 'ZIP code must be minimum 6 digits';
        return false;
      }
    }
  }


  submitEditContacts() {
    this.g.loaderDisplay = "display";
    this.statusText10 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    this.statusText7 = "";
    this.statusText8 = "";
    this.statusText9 = "";

    if (this.editContacts.customerType == '' || this.editContacts.customerType === null || this.editContacts.customerType === undefined || this.editContacts.customerType === 'undefined') {
      this.statusText10 = 'Please enter company name';
    }
    if (this.editContacts.contactName == '' || this.editContacts.contactName === null || this.editContacts.contactName === undefined || this.editContacts.contactName === 'undefined') {
      this.statusText2 = 'Please enter contact name';
    }
    if (this.editContacts.email == '' || this.editContacts.email === null || this.editContacts.email === undefined || this.editContacts.email === 'undefined') {
      this.statusText3 = 'Please enter email';
    }
    if (this.editContacts.mobile == '' || this.editContacts.mobile === null || this.editContacts.mobile === undefined || this.editContacts.mobile === 'undefined') {
      this.statusText4 = 'Please enter phone number';
    } else if (this.editContacts.mobile.toString().length != 10) {
      this.statusText4 = 'Phone number must be minimum 10 characters';
    }
    for (let add of this.addresses) {
      add.addressType = "SHIPPING";
      if (add.address1 == '' || add.address1 === null || add.address1 === undefined || add.address1 === 'undefined') {
        this.statusText5 = 'Please enter address1';
      }
      if (add.city == '' || add.city === null || add.city === undefined || add.city === 'undefined') {
        this.statusText6 = 'Please enter city';
      }
      if (add.state == '' || add.state === null || add.state === undefined || add.state === 'undefined') {
        this.statusText7 = 'Please enter state';
      }
      if (add.zip == '' || add.zip === null || add.zip === undefined) {
        this.statusText8 = 'Please enter zip';
      } else if (add.zip.toString().length != 6) {
        this.statusText8 = 'Please must be minimum 6 characters';
      }
    }
    if (this.statusText2 != "" || this.statusText3 != "" || this.statusText4 != "" || this.statusText5 != "" || this.statusText6 != "" || this.statusText7 != "" || this.statusText8 != "" || this.statusText10 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    //this.addresses.addressType = "SHIPPING";
    this.editContacts.addresses = this.addresses;
    this.http.post(environment.apiUrl + 'api/updateAOContacts', this.editContacts,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Contact', 'Edited successfully');

          this.router.navigate(['/admin/contacts']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
          this.statusText = "Edit creation Failed, please re-try.";
        });
  }

  createGeo() {

  }
}
